<template>
    <div>
        <div class="md:w-[900px] mx-auto p-4">
            <button @click="$router.push({name: 'demo'})" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 duration-200 rounded mt-4">
                <i class="fas fa-arrow-left mr-1"></i> Retour
            </button>
            <div v-if="!sendedAvis">
                <section class="mb-8 mt-8">
                    <div class="md:p-10">
                        <h3 class="text-4xl font-bold mb-2 text-slate-700 mb-4">Faites-nous un retour rapide</h3>
                        <p class="mb-10 font-light text-xl">
                            De nombreux agents immobiliers partagent déjà leur avis pour façonner l’avenir de ce projet. Ajoutez le vôtre et aidez-nous à créer un outil qui répond à vos besoins.
                        </p>
                        <div class="space-y-6 text-xl md:text-base bg-slate-100 p-4 border rounded-xl shadow-lg shadow-slate-500">
                            <!-- Question 1 -->
                            <div>
                                <label class="block font-bold mb-2">
                                    Selon vous, un logiciel comme celui-ci pourrait-il apporter une réelle valeur dans le secteur immobilier ?
                                </label>
                                <div class="md:flex items-center md:space-x-4 space-y-2 md:space-y-0">
                                    <label class="flex items-center">
                                        <input v-model="form.utile_immo" type="radio" name="value" value="Oui" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Oui</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_immo" type="radio" name="value" value="Non" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Non</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_immo" type="radio" name="value" value="Peut-être" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Peut-être</span>
                                    </label>
                                </div>
                            </div>
                            
                            <!-- Question 2 -->
                            <div>
                                <label class="block font-bold mb-2">
                                    À quel point ce concept serait-il utile dans votre entreprise ?
                                </label>
                                <div class="md:flex items-center md:space-x-4 space-y-2 md:space-y-0">
                                    <label class="flex items-center">
                                        <input v-model="form.utile_entreprise" type="radio" name="entreprise" value="Oui" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Très utile</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_entreprise" type="radio" name="entreprise" value="Non" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Pourquoi pas essayer</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_entreprise" type="radio" name="entreprise" value="Peut-être" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Pas utile</span>
                                    </label>
                                </div>
                            </div>
                            
                            <!-- Question 3 -->
                            <div>
                                <label class="block font-bold mb-2">
                                    Pensez-vous que vos clients apprécieront ce format interactif pour découvrir les biens ?
                                </label>
                                <div class="md:flex items-center md:space-x-4 space-y-2 md:space-y-0">
                                    <label class="flex items-center">
                                        <input v-model="form.utile_client" type="radio" name="clients" value="Oui" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Oui</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_client" type="radio" name="clients" value="Non" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Non</span>
                                    </label>
                                    <label class="flex items-center">
                                        <input v-model="form.utile_client" type="radio" name="clients" value="Peut-être" class="text-teal-500 focus:ring-teal-500">
                                        <span class="ml-2">Peut-être</span>
                                    </label>
                                </div>
                            </div>
                            
                            <!-- Question 4 -->
                            <div>
                                <label for="suggestions" class="block font-bold mb-0.5">
                                    Auriez-vous des suggestions ou idées pour améliorer cet outil ?
                                </label>
                                <div class="text-sm font-light mb-2">(Optionnel)</div>
                                <textarea v-model="form.more_info" id="suggestions" name="suggestions" rows="3" class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 p-1.5" placeholder="Votre réponse ici..."></textarea>
                            </div>
                            
                            <!-- Question 5 -->
                            <div>
                                <label for="company" class="block font-bold mb-0.5">
                                    Renseignez votre adresse email pour avoir un accès anticipé :
                                </label>
                                <div class="font-light text-sm mb-2">Rejoignez les 50 premiers agents immobiliers à contribuer et bénéficiez d’un accès gratuit à la version bêta. (Optionnel)</div>
                                <input v-model="form.email" type="text" id="company" name="company" class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 p-1.5" placeholder="Votre adresse email">
                            </div>
                            
                            <!-- Submit Button -->
                            <div>
                                <button :disabled="loadingSendForm" @click="sendForm" type="submit" :class="loadingSendForm ? '' : 'bg-slate-600 text-white py-2 px-4 rounded-md hover:bg-orange-700 duration-200'">
                                    <template v-if="loadingSendForm">Envoie en cours..</template>
                                    <template v-if="!loadingSendForm">
                                        <i class="fas fa-check mr-1 text-white"></i> Envoyer mes réponses
                                    </template>
                                </button>
                                <div class="font-light text-sm mt-6 md:mt-2">{{ nbAvis }} réponses récoltées depuis le lancement du formulaire</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div v-if="sendedAvis" class="bg-green-100 p-10 rounded-3xl text-green-800 mb-8">
                <h1 class="text-4xl font-bold">Merci pour votre participation !</h1>
                <p class="mt-4">
                    Nous vous remercions chaleureusement d’avoir pris le temps de partager votre avis dans le cadre de notre étude de marché. Vos retours nous aident à mieux comprendre vos besoins et à concevoir des solutions adaptées à vos attentes.
                </p>
                <p class="mt-2">
                    Votre contribution est essentielle pour nous permettre d’innover et de proposer des services qui font une réelle différence.
                </p>
                <p class="mt-2">
                    Si vous avez des questions ou souhaitez en savoir plus sur notre projet, n’hésitez pas à nous contacter.
                </p>
                <p class="mt-4">
                    Encore merci pour votre précieuse participation !
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loadingSendForm: false,
            sendedAvis: false,
            nbAvis: 0,
            form: {
                email: null,
                utile_immo: 1,
                utile_entreprise: 1,
                utile_client: 1,
                more_info: null
            }
        }
    },
    methods: {
        async sendForm() {
            if (!this.form.utile_immo || !this.form.utile_entreprise || !this.form.utile_client) {
                this.$toast.error('Formulaire incomplet')
                return
            }
            this.loadingSendForm = true
            await axios.post('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/avis', this.form)
            this.loadingSendForm = false
            this.form = {}
            this.sendedAvis = true
            localStorage.setItem('sended', 1)
        }
    },
    async mounted () {
        if (localStorage.getItem('sended')) {
            this.sendedAvis = 1
        }
        let response = await axios.get('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/nb-abis')
        this.nbAvis = response.data.length + 70
    },
}
</script>

<style lang="scss" scoped>

</style>